import {
  BiDisplayFormat,
  BiDisplayFormatKind,
  BiEmptyAs,
  kBiDisplayFormatKindNames,
} from '@euler/model/bi/format';
import { BiCell } from '@euler/model/bi/result';

/** A format in a few words: `金额 · 0 位小数 · 万/亿`. */
export function biFormatSummary(format: BiDisplayFormat): string {
  return [
    kBiDisplayFormatKindNames[format.kind],
    ...(format.decimals !== undefined ? [`${format.decimals} 位小数`] : []),
    ...(format.compact ? ['万/亿'] : []),
    ...(format.unit ? [`单位 ${format.unit}`] : []),
    ...(format.emptyAs === BiEmptyAs.Zero ? ['空值显示 0'] : []),
  ].join(' · ');
}

/** A value to show a kind's sample with when the column offers none. */
export const kBiFormatSamples: Record<BiDisplayFormatKind, BiCell> = {
  [BiDisplayFormatKind.Number]: 12345.6,
  [BiDisplayFormatKind.Currency]: 12345678,
  [BiDisplayFormatKind.Percent]: 0.256,
  [BiDisplayFormatKind.Duration]: 135,
};
